export const SET_SOCKET = "SET_SOCKET";
export const SET_COURSES = "SET_COURSES";
export const SET_TASKS = "SET_TASKS";
export const ADD_TASK = "ADD_TASK";
export const DELETE_TASK = "DELETE_TASK";
export const SET_CALENDAR_EVENTS = "SET_CALENDAR_EVENTS";
export const ADD_CALENDAR_EVENT = "ADD_CALENDAR_EVENT";
export const REMOVE_CALENDAR_EVENT = "REMOVE_CALENDAR_EVENT";
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_LINKS = "SET_LINKS";
export const LOAD_LINKS = "LOAD_LINKS";
export const LOAD_COURSES = "LOAD_COURSES";
export const LOAD_TIMESLOTS = "LOAD_TIMESLOTS";
export const SET_TIMESLOTS = "SET_TIMESLOTS";
export const UNDO_DELETE_TASK = "UNDO_DELETE_TASK";
export const DRAG_AND_DROP = "DRAG_AND_DROP";
export const ADD_NEW_SCHEDULED = "ADD_NEW_SCHEDULED";
export const FINISH_SCHEDULED = "FINISH_SCHEDULED";
export const UNDO_DELETE_SCHEDULED = "UNDO_DELETE_SCHEDULED";
export const DELETE_SCHEDULED = "DELETE_SCHEDULED";
export const SET_CURRENTLY_DRAGGING = "SET_CURRENTLY_DRAGGING";
export const LOAD_NEW_SCHEDULED = "LOAD_NEW_SCHEDULED";
